<template>
  <div>
    <h3 v-if="heading" class="wp-subsection-title wp-subsection-title--first">{{ heading }}</h3>
    <div v-if="active.length === 0" class="wp-section-subtitle">No active enrollments.</div>
    <div v-else class="wp-cards">
      <wrestler-enrollment-card v-for="enrollment in active" :key="enrollment.key" :enrollment="enrollment" :note="sharedWith(enrollment)"></wrestler-enrollment-card>
    </div>
    <!-- Past enrollments are tucked away behind a caret, with a preview of the
         newest so it isn't mistaken for empty-state text. Open, they're the
         same cards, with how and when each ended, newest first. -->
    <template v-if="ended.length > 0">
      <button type="button" class="wp-disclosure" :aria-expanded="showPast ? 'true' : 'false'" @click="showPast = !showPast">
        <i class="fa-solid fa-caret-right wp-section-toggle__icon" :class="{ 'is-open': showPast }" aria-hidden="true"></i>
        <span class="wp-disclosure__label">Past enrollments</span>
        <span class="wp-section-count">({{ ended.length }})</span>
        <span v-if="!showPast" class="wp-disclosure__preview">· {{ pastPreview }}</span>
      </button>
      <div v-if="showPast" class="wp-cards">
        <wrestler-enrollment-card v-for="enrollment in pastCards" :key="enrollment.key" :enrollment="enrollment" :note="sharedWith(enrollment)"></wrestler-enrollment-card>
      </div>
    </template>
  </div>
</template>
<script>
import WrestlerEnrollmentCard from './wrestler_enrollment_card.vue';

// A wrestler's active enrollment cards and (behind a toggle) past ones, for the
// wrestler page's Enrollments section and each kid's section on a parent's or
// coach's page. Enrollments covering more kids (a sibling registration) say
// who else they cover there.
export default {
  name: 'wrestler-enrollment-list',
  components: { WrestlerEnrollmentCard },
  props: {
    active: { type: Array, required: true },
    ended: { type: Array, required: true },
    // The kid whose section this is; others on an enrollment are "Shared with"
    wrestlerId: { type: Number, default: null },
    heading: { type: String, default: null },
  },
  data() {
    return {
      showPast: false,
    };
  },
  computed: {
    // "Unlimited, canceled Jun 30, 2025" (the newest), "and 2 more"
    pastPreview() {
      const latest = this.ended[0];
      const status = _.compact([latest.past.badge.text.toLowerCase(), latest.past.dateText]).join(' ');
      const first = `${latest.title}, ${status}`;
      return this.ended.length > 1 ? `${first} and ${this.ended.length - 1} more` : first;
    },
    // An ended enrollment's card says how it ended (Canceled / Ended / Unpaid)
    // and when, and links to the subscription or session like the row did
    pastCards() {
      return this.ended.map((enrollment) => ({
        ...enrollment,
        badge: enrollment.past.badge,
        endedNote: enrollment.past.when,
        link: enrollment.past.link,
        failing: false,
      }));
    },
  },
  methods: {
    // "Shared with Talia Fer"; past two, "Shared with Talia Fer, Leo Fer & 2 more"
    sharedWith(enrollment) {
      if (this.wrestlerId === null) {
        return null;
      }
      const names = (enrollment.wrestlers || []).filter((w) => w.id !== this.wrestlerId).map((w) => w.name);
      if (names.length === 0) {
        return null;
      }
      const list = names.length <= 2 ? names.join(' & ') : `${names.slice(0, 2).join(', ')} & ${names.length - 2} more`;
      return `Shared with ${list}`;
    },
  },
};
</script>
